export default __webpack_public_path__ + "static/media/adatkezelesi.4ef04d52.pdf";